const textEncoder = new TextEncoder()
const textDecoder = new TextDecoder()

/**
 * 將 string 轉為 Base64 格式
 * @param {string} src 目標字串
 * @param {object} options
 * @returns {string} Base64 string
 */
export function encode(src, {urlSafeMode}) {
  const srcArray = textEncoder.encode(src)
  return encodeFromUint8Array(srcArray, {urlSafeMode})
}

/**
 * 將 Uint8Array 的資料轉為 Base64 格式
 * @param {Uint8Array} src 目標字串
 * @param {object} options
 * @returns {string} Base64 string
 */
export function encodeFromUint8Array(src, {urlSafeMode}) {
  let result = ''

  // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
  const maxargs = 0x1000
  for (let i = 0; i < src.length; i += maxargs) {
    result += String.fromCharCode(...src.subarray(i, i + maxargs))
  }
  result = btoa(result)

  // 如果是 UrlSafeMode，將 `+` 和 `/` 分別換成 `-` 和 `_`
  if (urlSafeMode) {
    result = result
      .replace(/=/g, '')
      .replace(/[+\/]/g, (c) => (c === '+') ? '-' : '_')
  }
  return result
}

/**
 * 將 Base64 格式字串轉回原字串 (支援 Url Safe 模式)
 * @param {String} base64Str Base64 格式字串
 * @returns {string} 原字串
 */
export function decode(base64Str) {
  // 如果是 Url-safe 先改為原版的 Base64 格式 (換為 + 和 /)
  base64Str = base64Str.replace(/[-_]/g, (c) => c === '-' ? '+' : '/')

  return textDecoder.decode(_toUint8Array(base64Str))
}

function _toUint8Array(a) {
  return Uint8Array.from(atob(a), c => c.charCodeAt(0))
}

/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
 */
export function isValid(src) {
  if (typeof src !== 'string') {
    return false
  }

  const s = src.replace(/\s+/g, '').replace(/={0,2}$/, '')
  return !/[^\s0-9a-zA-Z+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s)
}
